export function calculateTier(totalQty, tiers) {
  const sorted = [...tiers].sort((a, b) => a.minQty - b.minQty)
  let current = sorted[0]
  let nextIdx = 1
  for (let i = 0; i < sorted.length; i++) {
    if (totalQty >= sorted[i].minQty) {
      current = sorted[i]
      nextIdx = i + 1
    }
  }
  const next = sorted[nextIdx] || null
  const toNext = next ? next.minQty - totalQty : 0
  return { current, next, toNext }
}

export function buildCartItems(state) {
  const items = []
  for (const grid of state.grids) {
    for (const row of grid.sizes) {
      if (row.qty > 0) {
        items.push({ id: row.variantId, quantity: row.qty })
      }
    }
  }
  return items
}

export function buildWhatsAppText(state) {
  const lines = ['Olá! Quero montar este pedido:']
  let total = 0
  for (const grid of state.grids) {
    const filled = grid.sizes.filter(s => s.qty > 0)
    if (filled.length === 0) continue
    const parts = filled.map(s => `${s.qty} ${s.size}`).join(', ')
    lines.push(`• ${grid.productTitle}: ${parts}`)
    total += filled.reduce((sum, s) => sum + s.qty, 0)
  }
  lines.push(`Total: ${total} un`)
  if (state.personalization && state.personalization.enabled) {
    lines.push(`Personalização: ${state.personalization.description || 'sim'}`)
  }
  lines.push('Preciso de proposta comercial.')
  return lines.join('\n')
}

if (typeof window !== 'undefined') {
  window.UniformeLogic = { calculateTier, buildCartItems, buildWhatsAppText }
}
